<template>
    <!-- 列表 详情 缺少订单来源字段  导出接口 详情取消日志接口-->
    <div class="content">
        <div class="content-head" v-if="showQuery">
            <el-form :inline="true" class="demo-form-inline">
                <el-form-item label="分款状态">
                    <el-select v-model="params.auditstatus" placeholder="请选择" class="el-select-medium">
                        <el-option v-for="item in auditstatusopt" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="凭证ID">
                    <el-input autocomplete="on" name="Receipt_ReceiptID" v-model="params.Receipt_ReceiptID" placeholder="" clearable class="el-select-medium"></el-input>
                </el-form-item>
                <el-form-item label="汇款单位">
                    <el-input autocomplete="on" name="Receipt_Code" v-model="params.Receipt_Code" placeholder="" clearable class="el-select-medium"></el-input>
                </el-form-item>
                <el-form-item label="汇款金额">
                    <el-input autocomplete="on" name="Receipt_TotalAmount" v-model="params.Receipt_TotalAmount" placeholder="" clearable class="el-select-medium"></el-input>
                </el-form-item>

                 <el-form-item label="工程名称">
                    <el-input autocomplete="on" name="project_name" v-model="params.Orders_ProjectName" placeholder="" clearable class="el-select-medium"></el-input>
                </el-form-item>

                 <el-form-item label="客户名称">
                    <el-input autocomplete="on" name="customer_name" v-model="params.Orders_CustomerName" placeholder="" clearable class="el-select-medium"></el-input>
                </el-form-item>

                 <el-form-item label="业务员">
                    <el-input autocomplete="on" name="officeman" v-model="params.OwnerName" placeholder="" clearable class="el-select-medium"></el-input>
                </el-form-item>

                <el-form-item label="ERP订单号">
                    <el-input autocomplete="on" name="Receipt_OrdersERPSN" v-model="params.Receipt_OrdersERPSN" placeholder="" clearable class="el-select-medium"></el-input>
                </el-form-item>
                <el-form-item label="最后一次分款时间" v-if="isFiltration">
                    <el-date-picker v-model="params.date_start" type="date" placeholder="开始日期" value-format="yyyy-MM-dd" clearable></el-date-picker>
                    <span style="margin: 0 5px">至</span>
                    <el-date-picker v-model="params.date_end" type="date" placeholder="结束日期" value-format="yyyy-MM-dd" clearable></el-date-picker>
                </el-form-item>
                <el-form-item label="订单ID" v-if="isFiltration">
                    <el-input autocomplete="on" name="Receipt_Code" v-model="params.Receipt_OrdersID" placeholder="" clearable class="el-select-medium"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getOrdersDistributetReceipt(true)" icon="el-icon-search" :loading="loadingBtn">搜索</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button @click="onRefresh" icon="el-icon-refresh">重置</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button @click="setFiltration" :icon="!isFiltration ? 'el-icon-arrow-down' : 'el-icon-arrow-up'">
                        {{ !isFiltration ? '展开' : '收起' }}
                    </el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="content-table">
            <div class="content-table-title" v-if="showQuery">
                明细管理
                <el-dropdown trigger="click">
                    <el-button type="primary">
                        导出
                        <i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item>
                            <span @click="getOrdersDistributet_Export()">导出查询信息</span>
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
            <el-table :row-class-name="tableRowClassName" @row-click="handleRowClick" :data="tableData" border :height="maxheight" style="width: 100%" :header-cell-style="{ backgroundColor: '#F5F7FA' }" v-loading="loadingBtn">
                <!-- <el-table-column prop="Receipt_ID" label="ID" width="80" align="center" fixed="left" /> -->
                <el-table-column prop="Orders_ProjectName" label="工程名称" width="220" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="Receipt_BandName" show-overflow-tooltip width="80" label="汇入银行" align="center">
                    <template slot-scope="scope">
                        <span v-html="scope.row.Receipt_BandName"></span>
                    </template>
                </el-table-column>
                <el-table-column prop="Receipt_PayDate" show-overflow-tooltip width="100" label="付款日期" align="center">
                    <template slot-scope="scope">
                        <span>{{ scope.row.Receipt_PayDate | formatDate }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="Receipt_Code" show-overflow-tooltip min-width="220" label="汇款单位" align="center"></el-table-column>
                <el-table-column prop="Orders_CustomerName" show-overflow-tooltip min-width="220" label="客户名称" align="center"></el-table-column>
                <el-table-column prop="OwnerName" show-overflow-tooltip min-width="100" label="业务员" align="center"></el-table-column>
                <el-table-column prop="Receipt_TotalAmount" show-overflow-tooltip width="100" label="汇款金额" align="center">
                    <template slot-scope="scope">
                        ￥
                        <span>{{ scope.row.Receipt_TotalAmount }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="Receipt_Amount" show-overflow-tooltip width="100" label="分款金额" align="center">
                    <template slot-scope="scope">
                        ￥
                        <span>{{ scope.row.Receipt_Amount }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="Receipt_OrdersERPSN" show-overflow-tooltip width="100" label="ERP订单号" align="center"></el-table-column>
                <el-table-column prop="AuditStatus" show-overflow-tooltip width="100" label="分款状态" align="center">
                    <template slot-scope="scope">
                        <span :class="judgeColor(scope.row.AuditStatus)">
                            {{ scope.row.AuditStatus }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="Receipt_ThirdName" show-overflow-tooltip width="120" label="是否需第三方审核" align="center"></el-table-column>
                <el-table-column prop="Receipt_ThirdScanName" show-overflow-tooltip label="第三方审核状态" align="center" width="120"></el-table-column>
                <el-table-column prop="Receipt_DisaccordName" show-overflow-tooltip label="付款不一致审核状态" align="center" width="140"></el-table-column>
                <el-table-column prop="Receipt_Lasttime" show-overflow-tooltip label="最后一次分款时间" align="center" width="150">
                    <template slot-scope="scope">
                        <span v-if="scope.row.Receipt_Lasttime.indexOf('0001') >= 0"></span>
                        <span v-else>{{ scope.row.Receipt_Lasttime | formatDate }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="Receipt_OrdersID" label="订单ID" width="80" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="Orders_SourceName" label="订单来源" width="80" show-overflow-tooltip align="center"></el-table-column>
                <el-table-column prop="Receipt_ReceiptID" label="凭证ID" width="100" show-overflow-tooltip align="center"></el-table-column>
              
                <el-table-column label="操作" align="center" width="100" fixed="right">
                    <template slot-scope="scope">
                        <div class="operation-bar">
                            <span class="operation-bar-block" @click="handleOpen(scope.row)">详情</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div>
                <Pagination :paginationOptions="paginationOptions" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
            </div>
        </div>
        <!-- ----------------详情信息-------------------->
        <el-dialog title="分款记录查看" :visible.sync="isDrawer" :before-close="handleClose" width="1200px" :close-on-click-modal="false">
            <div>
                <el-row :gutter="20">
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">订单ID ：</div>
                            <div>{{ details.Receipt_OrdersID }}</div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">订单来源：</div>
                            <div>{{ details.Orders_SourceName }}</div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">凭证ID：</div>
                            <div>{{ details.Receipt_ReceiptID }}</div>
                        </div>
                    </el-col>

                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">付款凭证类型：</div>
                            <div>{{ details.Receipt_Type }}</div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">汇入银行：</div>
                            <div>{{ details.Receipt_BandName }}</div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">汇款单位：</div>
                            <div>{{ details.Receipt_Code }}</div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">付款日期：</div>
                            <div>{{ details.Receipt_PayDate | formatDate }}</div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">汇款金额：</div>
                            <div>￥{{ details.Receipt_TotalAmount }}</div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">分款金额：</div>
                            <div>￥{{ details.Receipt_Amount }}</div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">ERP订单号：</div>
                            <div>{{ details.Receipt_OrdersERPSN }}</div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">分款状态：</div>
                            <div>
                                <span :style="details.AuditStatus == '已审核' || details.AuditStatus == '分款成功' ? 'color: #13ce66' : 'color: red'">{{ details.AuditStatus }}</span>
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">是否需第三方审核：</div>
                            <div>{{ details.Receipt_ThirdName }}</div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">第三方审核状态：</div>
                            <div>{{ details.Receipt_ThirdScanName }}</div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">付款不一致审核状态：</div>
                            <div>{{ details.Receipt_DisaccordName }}</div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">最后一次分款时间：</div>
                            <div v-if="details.Receipt_Lasttime.indexOf('0001') >= 0"></div>
                            <div v-else>{{ details.Receipt_Lasttime | formatDate }}</div>
                        </div>
                    </el-col>
                     <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">分款时间：</div>
                            <div v-if="details.Receipt_Lasttime.indexOf('0001') >= 0"></div>
                            <div v-else>{{ details.Receipt_Addtime | formatDates }}</div>
                        </div>
                    </el-col>
                     <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">分款人：</div>
                            <div v-if="details.Receipt_Lasttime.indexOf('0001') >= 0"></div>
                            <div v-else>{{ details.OwnerName }}</div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">取消日志：</div>
                            <el-table :data="cancelLogs" border style="width: 100%" :header-cell-style="{ backgroundColor: '#F5F7FA' }" v-loading="loadingBtn" :row-class-name="tableRowClassName" @row-click="handleRowClick">
                                <el-table-column prop="" label="序号" width="60" align="center">
                                    <template slot-scope="scope">
                                        {{ scope.$index + 1 }}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="" label="时间" width="150" align="center">
                                    <template slot-scope="scope">
                                        {{ scope.row.Log_AddTime | formatDates }}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="Log_User" label="操作人" width="150" align="center" show-overflow-tooltip></el-table-column>
                                <el-table-column prop="Log_Remark" label="备注" show-overflow-tooltip align="center"></el-table-column>
                            </el-table>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <span slot="footer" class="dialog-footer" style="display: flex; justify-content: center">
                <el-button @click="handleClose()">关闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import Pagination from '@/components/Pagination.vue';
import { myMixin } from '@/utils/mixin.js';
import { downloadFile, toLowerCaseKeys } from '@/utils/utils.js';
import { cloneDeep } from 'lodash';
export default {
    name: 'subdivisionRecordmanagement',
    mixins: [myMixin],
    components: {
        Pagination
    },
    props: {
        showQuery: {
            type: Boolean,
            default: true
        },
        projectName: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            loadingBtn: false,
            isDrawer: false,
            details: {
                AuditStatus: '',
                Receipt_ThirdName: '',
                Receipt_ThirdScanName: '',
                Receipt_DisaccordName: '',
                Orders_ProjectName: null,
                Customer_No: '86',
                Receipt_AddrID: 54,
                Receipt_AddrSource: 1,
                Receipt_Addtime: '',
                Receipt_Amount: 5400,
                Receipt_AuditStatus: 1,
                Receipt_BandName: '',
                Receipt_Code: '',
                Receipt_Disaccord: 0,
                Receipt_Errmsg: null,
                Receipt_Exptime: '',
                Receipt_ID: 912,
                Receipt_Lasttime: '',
                Receipt_OrdersERPSN: '',
                Receipt_OrdersID: 3503,
                Receipt_PayDate: '',
                Receipt_PaymentID: 1790,
                Receipt_ReceiptID: 716,
                Receipt_RemindDays: 0,
                Receipt_Third: 1,
                Receipt_ThirdScan: 0,
                Receipt_TotalAmount: 54500,
                Receipt_Type: ''
            },
            params: {
                date_start: '',
                date_end: '',
                auditstatus: 0,
                Receipt_OrdersID: '',
                Receipt_ReceiptID: '',
                Receipt_Code: '',
                Receipt_TotalAmount: '',
                Receipt_OrdersERPSN: '',
                Orders_CustomerName: '',
                OwnerName: '',
                Orders_ProjectName: ''
            },
            tableData: [],
            cancelLogs: [],
            auditstatusopt: [
                { value: 0, label: '全部' },
                { value: 1, label: '待审核' },
                { value: 2, label: '已审核' },
                { value: 3, label: '审核失败' },
                { value: 4, label: '分款中' },
                { value: 5, label: '分款成功' },
                { value: 6, label: '取消分款' },
                { value: 7, label: '分款失败' }
            ]
        };
    },
    mounted() {
        this.getOrdersDistributetReceipt(true);
    },
    methods: {
        handleSizeChange(newSize) {
            this.paginationOptions.PageSize = newSize;
            this.getOrdersDistributetReceipt();
        },
        handleCurrentChange(newPage) {
            this.paginationOptions.Page = newPage;
            this.getOrdersDistributetReceipt();
        },
        /*
    重置查询
    */
        onRefresh() {
            this.params = {
                date_start: '',
                date_end: '',
                auditstatus: 0,
                Receipt_OrdersID: '',
                Receipt_ReceiptID: '',
                Receipt_Code: '',
                Receipt_TotalAmount: '',
                Receipt_OrdersERPSN: ''
            };
            this.getOrdersDistributetReceipt(true);
        },
        /*
    列表查询
    */
        getOrdersDistributetReceipt(flag = false) {
            this.loadingBtn = true;
            if (flag) {
                this.paginationOptions = {
                    Page: 1,
                    total: 0,
                    PageSize: 40
                };
            }
            let params = { ...this.params };

            this.$newsApi
                .getOrdersDistributetReceipt(this.filteropt())
                .then((res) => {
                    if (res.data.Resultcode == 0) {
                        this.tableData = res.data.data;
                        this.paginationOptions.total = res.data.RecordCount;
                    } else {
                        this.tableData = [];
                        this.paginationOptions.total = 0;
                    }
                })
                .finally(() => (this.loadingBtn = false));
        },
        filteropt() {
            let params = cloneDeep(this.params);

            return { json: JSON.stringify(params), Page: this.paginationOptions.Page, PageSize: this.paginationOptions.PageSize };
        },
        /*
   导出
   */
        getOrdersDistributet_Export() {
            this.$newsApi.getOrdersDistributet_Export(this.filteropt()).then((res) => {
                if (res.data.Resultcode == 0) {
                    downloadFile(res.data.data, res.data.Resultinfo);
                }
            });
        },
        handleOpen(row) {
            this.isDrawer = true;
            this.getOrdersDistributetReceiptByID(row.Receipt_ID);
        },
        handleClose() {
            this.isDrawer = false;
        },
        /*
    日志信息
    */
        getMKLogsByTargetID(Receipt_ID) {
            this.$newsApi.getMKLogsByTargetID({ Target_ID: Receipt_ID, Target_Type: 2 }).then((res) => {
                if (res.data.Resultcode == 0) {
                    this.cancelLogs = res.data.data;
                }
            });
        },
        /*
    详情信息
    */
        getOrdersDistributetReceiptByID(Receipt_ID) {
            this.$newsApi.getOrdersDistributetReceiptByID({ Receipt_ID }).then((res) => {
                if (res.data.Resultcode == 0) {
                    this.details = res.data.data;
                    this.getMKLogsByTargetID(Receipt_ID);
                }
            });
        }
    }
};
</script>
<style scoped lang="scss">
.description-view {
    /deep/ .el-descriptions-item__label {
        color: #333333 !important;
    }
}
.required {
    color: red;
    margin-left: 4px;
}
.hw-form-item {
    padding: 10px 0;
    display: flex;
    align-items: center;

    &-label {
        text-align: right;
        width: 140px;
    }
}
.content-head {
    padding: 15px 20px 5px 20px;
}
.el-form-item--small.el-form-item {
    margin-bottom: 5px;
}
</style>
